import React from 'react';
import type { EXAM_CONFIG_FIELD_DROPDOWN_TYPE } from 'components/AppService/ExamInCoreConfiguration/helpers';
import type { TConfigureFieldLocal } from 'slices/examInCoreSettings.slice';
import type { ValueOf } from 'types/utils.type';
import { Select } from '@timeedit/ui-components/antd';

const { Option } = Select;

type Props = {
  value: string | null;
  options: { label: string; value: string }[];
  dropdownData?: {
    isLoading: boolean;
    options: { label: string; value: string }[];
  };
  isDisabled?: boolean;
  onChangeDropdown?: ({ config, type, value }: TConfigureFieldLocal) => void;
  config: string;
  type: ValueOf<typeof EXAM_CONFIG_FIELD_DROPDOWN_TYPE>;
};

const ExamInCoreConfigurationDropdown = ({
  value = '',
  options = [],
  onChangeDropdown,
  config,
  type,
  dropdownData = {
    isLoading: false,
    options: [],
  },
  isDisabled = false,
}: Props) => {
  const handleOnChange = (value: string) => {
    onChangeDropdown && onChangeDropdown({ config, type, value });
  };

  return (
    <Select
      loading={dropdownData.isLoading}
      value={value}
      placeholder="Please select"
      style={{ width: 120 }}
      onChange={handleOnChange}
      disabled={isDisabled}
    >
      {[...options, ...dropdownData.options].map((option, index) => (
        <Option key={index} value={option.value}>
          {option.label}
        </Option>
      ))}
    </Select>
  );
};

export default ExamInCoreConfigurationDropdown;
